/*
    2019-10-21
    曹秀芳
    增加各工位循环周期时间功能,
    2019-12-19
    张帅
    增加机器运行状态顶部数据监控版样式修改
    2019-9-1
    赵祥悦
    钢丝圈设备增加数据显示
*/ 
<template>
  <div class="machine mainWrap machineTime"  v-loading.fullscreen.lock="fullscreenLoading">
    <el-container style="height:100%;">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav :msg="`/EquipmentDashBoard/${machineId}`" ref="mychild"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
        <el-main>
          <!-- <div> -->
          <div style="position: relative;" :class="[getMachineInfo.machineStatus===5||getMachineInfo.machineStatus===0||getMachineInfo.machineStatus===4?'machineMain maskMain':'machineMain']">
            <!-- 蒙版 -->
            <div class="mask maskNoMachine" v-show="noMachine">
              <p style="font-size:30px">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</p>
            </div>
            <div class="mask" :class="{offlineMask:getMachineInfo.machineStatus === 5, notConnectedMask: getMachineInfo.machineStatus === 0}" v-show="!noMachine">
              <p v-if="getMachineInfo.machineStatus === 5">{{$t('MachineDashBoard.maskOffline')}}</p>
              <p v-else-if="getMachineInfo.machineStatus === 0">{{$t('MachineDashBoard.maskNotConnected')}}</p>
              <p v-else-if="getMachineInfo.machineStatus === 4">{{$t('MachineDashBoard.maskNoproduction')}}</p>
            </div>
            <!-- </div> -->
            <div class="dlcontent">
              <!-- 机器信息 -->
              <div class="machineInfo machineChart">
                <div class="machineInfoTime">
                  <!--最近循环时间-->
                  <div class="stateWrap last">
                    <span class="dis">{{$t('MachineDashBoard.stateDescribe1')}}:</span>
                    <span class="ms" v-if="getMachineInfo.lastCycle<300 || getMachineInfo.lastCycle ==  '-'">
                      <span class="val" >{{getMachineInfo.lastCycle}} <span>s</span></span>
                    </span>
                    <span v-else class="ms">
                      <span class="val">{{getMachineInfo.lastCycle.split(":")[0]}}<span>m</span></span>
                      <span class="vals">{{getMachineInfo.lastCycle.split(":")[1]}}<span>s</span></span>
                    </span>
                  </div>
                  <!--平均循环时间-->
                  <div class="stateWrap average">
                    <span class="dis">{{$t('MachineDashBoard.stateDescribe3')}}:</span>
                    <span v-if="getMachineInfo.averageCycle<300 || getMachineInfo.averageCycle ==  '-'" class="ms">
                      <span class="val" >{{getMachineInfo.averageCycle}} <span>s</span></span>
                    </span>
                    <span v-else class="ms">
                      <span class="val">{{getMachineInfo.averageCycle.split(":")[0]}}<span>m</span></span>
                      <span class="vals">{{getMachineInfo.averageCycle.split(":")[1]}}<span>s</span></span>
                    </span>
                  </div>
                  <!--最佳循环时间-->
                  <div class="stateWrap best">
                    <span class="dis">{{$t('MachineDashBoard.stateDescribe4')}}:</span>
                    <span v-if="getMachineInfo.bestCycle<300 || getMachineInfo.bestCycle ==  '-'" class="ms">
                      <span class="val" >{{getMachineInfo.bestCycle}} <span>s</span></span>
                    </span>
                    <span v-else class="ms">
                      <span class="val">{{getMachineInfo.bestCycle.split(":")[0]}}<span>m</span></span>
                      <span class="vals">{{getMachineInfo.bestCycle.split(":")[1]}}<span>s</span></span>
                    </span>
                    <p class="stateWrap bestTime">{{getMachineInfo.bestTireTime}}</p>
                  </div>
                </div>
                <div class="chartWrap">
                  <div id="myChart"></div>
                </div>
              </div>
              <!-- 各工位循环周期时间 -->
              <div v-show="showstation" class="machineInfo cycleTime">
                <h2 class="cycleTime-title">{{$t('MachineDashBoard.cycletime')}}</h2>
                <div class="cycleTime-title-box">
                  
                  <div class="cycleTime-datePicker">
                    <!-- 计算周期 -->
                    <p>{{$t('MachineDashBoard.class6')}}：</p>
                    <el-date-picker
                      v-model="datePicker"
                      type="datetimerange"
                      :editable="editable"
                      @change="changeTime"
                      :picker-options="pickerOptions"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      range-separator="~"
                      :start-placeholder="$t('MachineDashBoard.StartTime')"
                      :end-placeholder="$t('MachineDashBoard.EndTime')"
                      popper-class="timePopup"
                      align="right"
                    >
                    </el-date-picker>
                  </div>
                </div>
                <div>
                  <div class="cycleBodyHead">
                    <div class="headLeft">
                      <div class="cycleHead-item cycleHead-item-active">{{$t('MachineDashBoard.station')}}</div>
                    </div>
                    <div class="cycle-headRight">
                      <div class="cycleHead-item">{{$t('MachineDashBoard.current')}}</div>
                      <div class="cycleHead-item">{{$t('MachineDashBoard.best')}}</div>
                      <div class="cycleHead-item">{{$t('MachineDashBoard.average')}}</div>
                      <div class="cycleHead-item">{{$t('MachineDashBoard.output')}}</div>
                    </div>
                  </div>
                  <div class="cycleBodyContent">
                    <div class="cycleContent-item" v-for="(item,index) in cycleData" :key="index">
                      <div class="cycleImg-box">
                        <div> 
                          <img class="cycleImg" v-if="item.station_flag==='CC'" src="../assets/img/cycleTime/cycle-CC.png"/> 
                          <img class="cycleImg" v-if="item.station_flag==='CC+SP'" src="../assets/img/cycleTime/cycle-CC.png"/> 
                          <img class="cycleImg" v-if="item.station_flag==='BT'" src="../assets/img/cycleTime/cycle-BT.png"/>
                          <img class="cycleImg" v-if="item.station_flag==='SP' || item.station_flag==='WD'" src="../assets/img/cycleTime/cycle-SP.png"/>
                          <img class="cycleImg" v-if="item.station_flag==='OP1'" src="../assets/img/cycleTime/cycle-OP1.jpg"/> 
                          <img class="cycleImg" v-if="item.station_flag==='OP2'" src="../assets/img/cycleTime/cycle-OP2.jpg"/> 
                          <img class="cycleImg" v-if="item.station_flag==='OP3'" src="../assets/img/cycleTime/cycle-OP3.jpg"/> 
                          <img class="cycleImg" v-if="item.station_flag==='OP4'" src="../assets/img/cycleTime/cycle-OP4.jpg"/> 
                        </div>
                        <div class="cycleModel">{{item.stepName}}</div>
                      </div>
                      <div class="ContentItem-left">
                        <div class="cycle-leftItem">
                          <div class="cycle-second">
                            <div v-if="item.currentCycleTime">
                              <p v-if="item.currentCycleTime<300">
                                <span class="cycle-secondNum">{{item.currentCycleTime}}</span>
                                <span class="cycle-secondS">s</span>
                              </p>
                              <p v-else>
                                <span class="cycle-secondNum">{{item.currentCycleTime.split(":")[0]}}</span>
                                <span class="cycle-secondS">m</span>
                                <span class="cycle-secondNum" style="font-size:2.5em;margin-left:3px;">{{item.currentCycleTime.split(":")[1]}}</span>
                                <span class="cycle-secondS">s</span>
                              </p>
                            </div>
                            <span v-show="!item.currentCycleTime && item.currentCycleTime!==0" class="cycle-secondNum">-</span>
                          </div>
                          <div class="time">{{item.currentCycleDate}}</div>
                        </div>
                        <div class="short-border"></div>
                        <div class="cycle-leftItem">
                          <div class="cycle-second">
                            <div v-if="item.bestCycle">
                              <p v-if="item.bestCycle<300">
                                <span class="cycle-secondNum">{{item.bestCycle}}</span>
                                <span class="cycle-secondS">s</span>
                              </p>
                              <p v-else>
                                <span class="cycle-secondNum">{{item.bestCycle.split(":")[0]}}</span>
                                <span class="cycle-secondS">m</span>
                                <span class="cycle-secondNum" style="font-size:2.5em;margin-left:3px;">{{item.bestCycle.split(":")[1]}}</span>
                                <span class="cycle-secondS">s</span>
                              </p>
                            </div>
                            <span v-show="!item.bestCycle && item.bestCycle!==0" class="cycle-secondNum">-</span>
                          </div>
                          <div class="time">{{item.bestCycleDate}}</div>
                        </div>
                        <div class="short-border"></div>
                        <div class="cycle-leftItem">
                          <div class="cycle-second">
                            <div v-if="item.averageCycle">
                              <p v-if="item.averageCycle<300">
                                <span class="cycle-secondNum">{{item.averageCycle}}</span>
                                <span class="cycle-secondS">s</span>
                              </p>
                              <p v-else>
                                <span class="cycle-secondNum">{{item.averageCycle.split(":")[0]}}</span>
                                <span class="cycle-secondS">m</span>
                                <span class="cycle-secondNum" style="font-size:2.5em;margin-left:3px;">{{item.averageCycle.split(":")[1]}}</span>
                                <span class="cycle-secondS">s</span>
                              </p>
                            </div>
                            <span v-show="!item.averageCycle && item.averageCycle!==0" class="cycle-secondNum">-</span>
                          </div>
                        </div>
                        <div class="short-border"></div>
                        <div class="cycle-leftItem">
                          <div class="cycle-second">
                            <span v-show="item.event || item.event===0" class="cycle-secondNum lastNum">{{item.event}}</span>
                            <span v-show="!item.event && item.event!==0" class="cycle-secondNum">-</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> 

              </div>

              <!-- 错误信息表 -->
              <div class="machineInfo tableWrap">
                <div class="miniTitle-box">
                  <div></div>
                  <h2 class="miniTitle">{{$t('MachineDashBoard.title1')}}</h2>
                  <el-button class="mores" @click="clickMore">{{$t('MachineDashBoard.more')}}...</el-button>
                </div>
                
                <!-- 表格 -->
                <el-table
                  :data="tableData"
                  fit
                  :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                  style="width: 100%;">
                  <el-table-column
                    min-width="80"
                    show-overflow-tooltip
                    :label="$t('EventRecord.tableTitle3')">
                    <template slot-scope="scope">
                        <span v-if="$store.state.lang===1" >{{scope.row.event}}</span>
                        <span v-else >{{scope.row.msgEn}}</span>
                        <!-- <span v-else-if="$store.state.lang!=1&&scope.row.msgEn!=''" >{{scope.row.msgEn}}</span> -->
                        <!-- <span v-else-if="$store.state.lang!=1&&scope.row.msgEn=='' ">-</span> -->
                      </template>
                  </el-table-column>
                  <el-table-column
                    prop="group"
                    min-width="60"
                    align='center'
                    show-overflow-tooltip
                    :label="$t('EventRecord.tableTitle4')"
                  >
                  </el-table-column>
                  <el-table-column
                    min-width="50"
                    align='center'
                    :label="$t('EventRecord.tableTitle6')">
                    <template slot-scope="scope">

                      <closeIcon v-if="scope.row.typeValue === 'FLT'" title="" class="typeIcon"/>
                      <span style="margin-left: 10px" class="flt">{{ scope.row.typeValue }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('EventRecord.tableTitle7')"
                    align='center'
                  >
                    <template slot-scope="scope" >
                      <p>{{scope.row.createTime | formatDate}}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('EventRecord.tableTitle9')"
                    align='center'
                  >
                    <template slot-scope="scope" >
                      <p v-if="scope.row.updateTime === undefined">-</p>
                      <p v-else>{{scope.row.updateTime | formatDate}}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    min-width="60"
                    :label="$t('EventRecord.tableTitle8')"
                    align='center'>
                    <template slot-scope="scope" >
                      <span v-if="scope.row.updateTime !== undefined">
                        {{ (scope.row.updateTime - scope.row.createTime) / 1000 }}&quot;
                      </span>
                      <span v-else>-</span>
                    </template>
                  </el-table-column>
                </el-table>
              </div>   
              <!--月产量-->
              <div class="machineInfo monthlyOutput">
                <div class="outputTitle">
                    <div></div>
                    <h2 class="miniTitle">{{$t('MachineDashBoard.title3')}}</h2>
                    <div class="output">
                      <el-button class="exportBtn" size="medium" icon="el-icon-download" @click="dlExcel()">{{$t('WorkShopDashBoard.exportBtn')}}</el-button>
                    </div>
                </div>
                <!--切换上下月-->
                <div class="changetime">
                    <el-button size="mini" @click="monthChange('last')" icon="el-icon-arrow-left" ></el-button>
                    <span class="nowTime">{{timevalue}}</span>
                    <el-button size="mini" @click="monthChange('next')" :disabled="btnDis" icon="el-icon-arrow-right" ></el-button>
                </div>
                <el-table
                  :data="monthTableData"
                  stripe
                  :cell-style="cellStyle"
                  :empty-text="$t('WorkShopDashBoard.noEquipmentTableMessage')"
                  style="width:100%;margin-top:10px;height:100%;"
                  fit>
                  <el-table-column
                    prop="name"
                    width="150">
                  </el-table-column>
                  <el-table-column
                    prop="totalTireInfo"
                    :label="$t('EventRecord.monthTableTitle1')"
                    header-align="center"
                    align="center"
                    width="135"
                    >  
                  </el-table-column>
                  <el-table-column
                    prop="refuelingTime"
                    :label="$t('EventRecord.monthTableTitle2')"
                    header-align="center"
                    width="170"
                    align="center">  
                  </el-table-column>
                  <el-table-column
                    :label="$t('EventRecord.monthTableTitle3')"
                    header-align="center"
                    align="center">  
                    <template class="table" slot-scope="scope" >
                      <div class="tableLine">
                        <div class="tableLeft">{{scope.row.bestPorduction}}</div>
                        <div class="tableRight">
                          <span  v-for="item in scope.row.bestPorductionDate" :key="item">{{item}}</span>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$t('EventRecord.monthTableTitle4')"
                    header-align="center"
                    align="center">  
                      <template class="table" slot-scope="scope">
                        <div class="tableLine">
                          <span class="tableLeft">{{scope.row.worstPorduction}}</span>
                          <div class="tableRight">
                            <span v-for="item in scope.row.worstPorductionDate" :key="item">{{item}}</span>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
                </el-table> 
              </div>
            </div>
          </div>
        </el-main>
      </el-scrollbar>
      <!-- 右侧边栏 -->
        <el-aside class="rightBox">
          <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
            <div class="rightBoxInfo">
              <!-- 头像收藏 -->
              <div class="rightBox-collect">
                <span></span>
                <!-- <img :src="getMachineInfo.photoImg" class="rightBox-machinePic"> -->
                <img v-if="getMachineInfo.id === 131" src="../assets/img/machine/131.jpg" class="rightBox-machinePic">
                <img v-else-if="getMachineInfo.id === 211" src="../assets/img/machine/TBM211.jpg" class="rightBox-machinePic">
                <img v-else-if="getMachineInfo.id === 201 || getMachineInfo.id === 202 || getMachineInfo.id === 196" src="../assets/img/gsq/gsqTop.jpg" class="rightBox-machinePic">
                <img v-else src="../assets/img/machine/machine01.png" class="rightBox-machinePic">
                <i v-if="isFavorited === 1" class="el-icon-star-on" @click="delFavorited()"></i>
                <i v-else-if="isFavorited !=1" class="el-icon-star-off" @click="addFavorited()"></i>
              </div>
              <!-- 运行状态 -->
              <div class="rightBox-machineStatus">
                <playIcon v-if="getMachineInfo.machineStatus === 1" title="" class="playIcon"/> 
                <stopIcon v-if="getMachineInfo.machineStatus === 4" title="" class="playIcon stop"/>
                <offlineIcon v-if="getMachineInfo.machineStatus === 5" title="" class="playIcon offline"/>
                <faultIcon v-if="getMachineInfo.machineStatus === 3" title="" class="playIcon fault"/>
                <standbyIcon v-if="getMachineInfo.machineStatus === 2" title="" class="playIcon standby"/>
                <notConnectedIcon v-if="getMachineInfo.machineStatus === 0" title="" class="playIcon notConnected"/>
                <span v-if="$store.state.lang ===0" :style="{color: stateColor}" style="font-size:15px;font-weight:bold;">{{machintLine[getMachineInfo.machineStatus]}}</span> 
                <span v-else  :style="{color: stateColor}" style="font-size:15px;font-weight:bold;" >{{machintLineCh[getMachineInfo.machineStatus]}}</span>
              </div>
              <!-- 切换设备 -->
              <equipment @change="getchange" class="machinevue" :machine="machineId" ></equipment>
              <!--车间名称-->
              <div class="title">
                <p class="name" v-if="$store.state.lang===0">
                  <span v-if="noMachine">-</span>
                  <span v-else>{{getMachineInfo.shopNameEn}}</span>
                </p>
                <p class="name" v-else>
                  <span v-if="noMachine">-</span>
                  <span v-else>{{getMachineInfo.shopNameZh}}</span>
                  <!-- <span >全钢成型车间</span> -->
                </p>
              </div>
              <!--当前班组-->
              <div class="rightBox-currentShift">
                <div class="rightBox-currentShift-title">{{$t('MachineDashBoard.infoTitle3')}}</div>
                <div class="rightBox-currentShift-content">{{getMachineInfo.currentShift +' '+ $t('MachineDashBoard.class3')}} </div>
              </div>
              <!--当前规格-->
              <div class="rightBox-currentShift">
                <div class="rightBox-currentShift-title">{{$t('MachineDashBoard.infoTitle6')}}</div>
                <div class="rightBox-currentShift-content ellipsis" v-if="'currentDimension' in getMachineInfo" :title="getMachineInfo.currentDimension" >{{getMachineInfo.currentDimension}} </div>
                <div class="rightBox-currentShift-content" v-else>-</div> 
              </div>
              <!--当前生产率-->
              <div class="rightBox-currentShift">
                <div class="rightBox-currentShift-title">{{$t('MachineDashBoard.stateDescribe7')}}</div>
                <div class="rightBox-currentShift-content">
                  <span>{{getMachineInfo.currentProductivity}}</span>
                  <span class="rightBox-unit">{{this.productUnit}}</span>
                </div>
              </div>
              <!--同时最大输出圈数-->
              <div class="rightBox-currentShift" v-if="getMachineInfo.currentTurns">
                <div class="rightBox-currentShift-title">{{$t('MachineDashBoard.stateDescribe8')}}</div>
                <div class="rightBox-currentShift-content">
                  <span>{{getMachineInfo.currentTurns}}</span>
                  <span class="rightBox-unit">{{$t('MachineDashBoard.class5')}}</span>
                </div>
              </div>
              <!--设备日报-->
              <div class="rightBox-currentShift card">
                <div class="rightBox-currentShift-title">{{$t('MachineDashBoard.title2')}}</div>
                <div class="list">
                  <el-button icon="el-icon-arrow-left" @click="changeTimePage('r')" :disabled="timeNowPage === timePageSize || timePageSize===0"></el-button>
                  <div v-if="timeList.length == 0" class="noTimeListTitle">{{$t('MachineDashBoard.noTimeList')}}</div>
                  <div class="cardWrap" ref="wrap" v-else>
                    <div class="card" v-for="(item, index) in timeList" :key="index" @mouseenter="showIndex = index" @mouseleave="showIndex = -1">
                      <p class="date"><span>{{item | formatDateManth}}</span>/<span>{{item | formatDateDay}}</span></p>
                      <p class="year">{{item | formatDateYear}}</p>
                      <!-- 下载蒙版 -->
                      <transition name="el-fade-in-linear">
                        <div class="dlMark" @click="dlPdf(item)"  v-show="show && showIndex === index"><downLoadIcon title=""/></div>
                      </transition>
                    </div>
                  </div>
                  <el-button icon="el-icon-arrow-right" @click="changeTimePage('l')" :disabled="timeNowPage === 1"></el-button>
                </div>
              </div>

            </div>
          </el-scrollbar>
        </el-aside>

    </el-container>
  </div>
</template>

<script>
import leftNav from "@/components/nav.vue"
import playIcon from "vue-material-design-icons/PlayCircle.vue"
import stopIcon from "vue-material-design-icons/StopCircle.vue"
import offlineIcon from "vue-material-design-icons/LanDisconnect.vue"
import faultIcon from "vue-material-design-icons/CloseCircle.vue"
import standbyIcon from "vue-material-design-icons/PauseCircle.vue"
import notConnectedIcon from "vue-material-design-icons/EarthOff.vue"
import listIcon from "vue-material-design-icons/FormatListBulleted.vue"
import clockIcon from "vue-material-design-icons/ClockOutline.vue"
import rightClockIcon from "vue-material-design-icons/Update.vue"
import timerIcon from "vue-material-design-icons/Timer.vue"
import helpIcon from "vue-material-design-icons/HelpCircle.vue"
import messageIcon from "vue-material-design-icons/MessageAlert.vue"
import alertIcon from "vue-material-design-icons/Alert.vue"
import closeIcon from "vue-material-design-icons/CloseCircle.vue"
import accountIcon from "vue-material-design-icons/AccountSupervisor.vue"
import historyIcon from "vue-material-design-icons/History.vue"
import downLoadIcon from "vue-material-design-icons/CloudDownload.vue"
//新增钢丝圈
import axis from "vue-material-design-icons/Axis.vue"

import {formatDate} from '../assets/js/date.js'
// import {Loading} from 'element-ui'
import equipment from "@/components/Equipment.vue"
export default {
  name: 'machine',
  components: {
    leftNav,
    playIcon,
    stopIcon,
    offlineIcon,
    faultIcon,
    standbyIcon,
    notConnectedIcon,
    listIcon,
    clockIcon,
    rightClockIcon,
    timerIcon,
    helpIcon,
    messageIcon,
    alertIcon,
    closeIcon,
    accountIcon,
    historyIcon,
    downLoadIcon,
    axis,
    equipment
  },
  data () {
    return {
      lineVal: [],
      saveLineVal: '',
      // 联动选择器数据
      options: [],
      // 机器ID
      machineId:101,
      // 获取的机器信息
      getMachineInfo: {
        id:'',
        photoImg:'',
        nameEn: '',
        lineNameEn: '',
        shopNameEn: '',
        factoryNameEn: '',
        machineStatus: '',
        currentTireDimension: '',
        currentShift: '',
        continuousRunning: '',
        currentProductivity: '',
        lastCycle: '',
        standardCycle: '',
        averageCycle: '',
        bestCycle: '',
        shiftPlan: '',
        estimateProductivity: ''
      },
      // 日志页数
      pageNo: 1,
      // 日志总页数
      totalPage: 1000,
      // 表格数据
      tableData: null,
      dataRun: null,
      isFavorited: null,
      //月产量表格数据
      monthTableData:[],
      //loading wrap
      loadingInstance: '',
      websock: null,
      show: true,
      showIndex: -1,
      timeList: [],
      timePageSize: null,
      timeNowPage: 1,
      //各工位循环周期时间的变量
      cycleData:[],
      CC:{},
      BT:{},
      SP:{},
      cycleShowId:'',
      cycleShowFactoryId:'',
      // 设备运行情况
      machintLine: ['Not Connected', 'running', 'standby', 'fault', 'stop', 'offline'],
      machintLineCh: ['未接入', '运行中', '待机', '故障', '停止', '离线'],
      stateColor: '#fff',
      productUnit: '',
      pickerMinDate: '',
      // 时间快捷键
      pickerOptions: {
        onPick: ({minDate}) => {
          this.pickerMinDate = minDate.getTime()
        },
        disabledDate: (time) =>{
          if (this.pickerMinDate !== '') {
            const day7 = 7 * 24 * 3600 * 1000
            let maxTime = this.pickerMinDate + day7
            let minTime = this.pickerMinDate - day7
            return (time.getTime() > maxTime || time.getTime() < minTime)
          }else {
            return ''
          }
        },
        shortcuts: [{
          text: this.$t('MachineDashBoard.pickTime1'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('MachineDashBoard.pickTime2'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 3);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('MachineDashBoard.pickTime3'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 8);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      //月产量选中月份
      timevalue:'',
      //当前月份
      nowMonth:'',
      //判断是否第一次调用
      //flag:true,
      btnDis:true,
      //时间选择器逻辑
      pickerNewOptions:{
        disabledDate:(time)=>{
          var times=Date.now()
          return time.getTime()>times;
          }
        },
      //选择的时间
      datePicker:[],
      //选中的时间开始时间与结束时间
      startTimePicker:'',
      endTimePicker:'',
      editable:false,
      fullscreenLoading: false,
      // 是否显示各工位循环周期时间
      showstation:true,
      noMachine:false,
      machineTimeArr:[],
      machineTimeList:[],
      barChart: null,
      resizeTimer: null,
    }
  },
  filters: {
    formatDateYear (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy')
    },
    formatDateManth (time) {
      var date = new Date(time)
      return formatDate(date, 'MM')
    },
    formatDateDay (time) {
      var date = new Date(time)
      return formatDate(date, 'dd')
    },
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'MM-dd hh:mm:ss')
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.websock.close()
        this.$nextTick(()=>{
          this.$parent.reload()
        })
      }
    },
    
  },
  created() {
    this.machineId = Number(this.$route.params.id)
    // this.machineId = ''
    //获取页面默认的工厂id和机器id，以判断 各工位循环周期时间 是否显示
    this.lineVal = [Number(this.$store.state.defaultFactoryId), Number(this.$store.state.defaultId)]
    this.doHandleDate()
  },
  mounted () {
    // if (this.$store.state.reloadState === false) {
    //   this.$store.state.reloadState = true
    //   this.$parent.reload()
    // }else{
      this.getManiceList()
      this.initWebSocket()
      this.$store.commit('authority' , this.$route.name)
    // }

  },
  destroyed () {
    // clearTimeout(this.dataRun)
    this.websock.close()
    clearInterval(this.resizeTimer)
    // this.loadingInstance.close()
  },
  methods: {
    add0(m){return m<10?'0'+m:m },
    format(shijianchuo){
      //shijianchuo是整数，否则要parseInt转换
      var time = new Date(shijianchuo);
      var y = time.getFullYear();
      var m = time.getMonth()+1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      var s = time.getSeconds();
      return y+'-'+this.add0(m)+'-'+this.add0(d)+' '+this.add0(h)+':'+this.add0(mm)+':'+this.add0(s);
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1||columnIndex === 2) {
        // 指定列号
        return 'font-weight:bold'
      } else if(columnIndex === 3){
        return 'color:#43cf7c;'
      } else if(columnIndex === 4){
        return 'color:#d74040;'
      }else {
        return ''
      }
    },
    // 切换计算周期的时间
    changeTime(){
      if (this.datePicker === null) {
        this.startTimePicker=''
        this.endTimePicker=''
        this.pickerMinDate = ''
        this.toWebsocketSendCon()
      }else if(this.datePicker!=null){
        this.startTimePicker=this.datePicker[0]
        this.endTimePicker=this.datePicker[1]
        this.toWebsocketSendCon()
      }
      
    },
    // 切换设备
    getchange(value){
      this.machineId=value
      this.lineVal[1]=value
      this.changeLine()
    },
    s_to_hs(s){
        //计算分钟
        //算法：将秒数除以60，然后下舍入，既得到分钟数
        var h;
        h  =   Math.floor(s/60);
        //计算秒
        //算法：取得秒%60的余数，既得到秒数
        s  =   Math.round(s%60);
        //将变量转换为字符串
        h    +=    '';
        s    +=    '';
        return h+':'+s;
    },
    s_to_mins(s){
        //计算分钟
        //算法：将秒数除以60，然后下舍入，既得到分钟数
        var h;
        h  =   Math.floor(s/60);
        //计算秒
        //算法：取得秒%60的余数，既得到秒数
        s  =   Math.round(s%60);
        //将变量转换为字符串
        h    +=    '';
        s    +=    '';
        if(h=='0')return s+'s';
        else if(s=='0')return h+'m';
        else return h+'m'+s+'s';
    },
    //获取当前的月份
    doHandleDate(){
      var myDate=new Date();
      var tYear=myDate.getFullYear();
      var tMonth=myDate.getMonth();
      var m=tMonth+1;
      this.nowMonth=`${tYear}-${m}`
      this.timevalue=this.nowMonth
    },
    //点击上一个月、下一个月按钮
    monthChange(type){
      var time=this.timevalue
      var timeArr=time.split('-')
      if(type==='last'){
        let newTime=''
        if(timeArr[1]-1===0){
          newTime=`${timeArr[0]-1}-12`
        }else{
          newTime=`${timeArr[0]}-${timeArr[1]-1}`
        }
        this.btnDis=false
        this.timevalue=newTime
        //this.toWebsocketSendCon(this.flag=false)
        this.toWebsocketSendCon()
      }else{
        //下个月的月份
        let newTime=''
        if(Number(timeArr[1])+1>12){
          newTime=`${Number(timeArr[0])+1}-01`
        }else{
          newTime=`${timeArr[0]}-${Number(timeArr[1])+1}`
        }
        if(String(this.nowMonth)===String(`${timeArr[0]}-${Number(timeArr[1])+1}`).trim()){
          this.btnDis=true
        }
        this.timevalue=newTime
        //this.toWebsocketSendCon(this.flag=false)
        this.toWebsocketSendCon()
      }
    },
    //选择时间后按钮禁用
    changeDate(){
      var time=this.timevalue
      var timeArr=time.split('-')
      if(this.nowMonth===`${timeArr[0]}-${Number(timeArr[1])}`){
        this.btnDis=true
      }else{
        this.btnDis=false
      }
      //this.toWebsocketSendCon(this.flag=false)
      this.toWebsocketSendCon()
    },
    //下载excel月产量
    dlExcel(){
      // let timeStr = formatDate(new Date(t), 'yyyy-MM-dd')
      let signTime = new Date().getTime()
      this.$store.commit('nowsign', signTime)
      window.open(`/download/equipmentMonthlyOutputExport?date=${this.timevalue}&machineId=${this.machineId}&language=${this.$store.state.lang}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`, '_blank')
    
    },
    // 初始化weosocket
    initWebSocket(){ 
      // if(this.machineId.length==0)return
      let _this = this
      // _this.loadingInstance = Loading.service({ fullscreen: true })
      _this.fullscreenLoading = true
      _this.websock = new WebSocket("ws://" + _this.$store.state.websocketws+_this.$store.state.newroute  + "/websocket-dashboardstation")
      // 接收服务器发来的消息
      _this.websock.onmessage = function (e) {
        if(e.data== "{}"){
            _this.fullscreenLoading = false
        }else{
        var data = JSON.parse(e.data)
        if(_this.startTimePicker==data['condition_startTime']&&_this.endTimePicker==data['condition_endTime']&&_this.timevalue==data['monthlyProductionTime']){
            let monthlyData=JSON.parse(data.monthlyProduction)
            if(monthlyData[0].totalTireInfo==0){
               monthlyData=[]
               _this.monthTableData=monthlyData
            }else{
               _this.monthTableData=JSON.parse(data.monthlyProduction);
            }
            let stationHidden = data.stationHidden +''
             //各工位循环周期时间
            if(stationHidden === 'false'){
              _this.cycleData=JSON.parse(data.station)
              _this.cycleData.forEach(element => {
                
                if(element.averageCycle){
                    element.averageCycle=Math.round(element.averageCycle * 10) / 10
                    if(element.averageCycle>=300){
                      element.averageCycle = _this.s_to_hs(element.averageCycle)
                    }
                }
                if(element.bestCycle && element.bestCycle>=300){
                  element.bestCycle = _this.s_to_hs(element.bestCycle)
                }
                if(element.currentCycleTime && element.currentCycleTime>=300){
                  element.currentCycleTime = _this.s_to_hs(element.currentCycleTime)
                }
              })
            }else{
              _this.showstation=false
            }
        }

        if (data['info'] !== null) {
          var info = JSON.parse(data['info'])
          if (info !== null) {
            _this.getMachineInfo = info
            // if(!info.currentTireDimension){
            //   info.currentTireDimension='-'
            // }
            // 动态修改机器运行状态颜色
            switch (info.machineStatus) {
              case 1:
                _this.stateColor = '#0bd70b'
                break;
              case 2:
                _this.stateColor = '#cfcf0b'
                break;
              case 3:
                _this.stateColor = '#d43030'
                break;
              case 4:
                _this.stateColor = '#4866ea'
                break;
              case 5:
                _this.stateColor = '#808080'
                break;
              case 0:
                _this.stateColor = '#383838'
                break;
            }
            if(!info.currentShift){
              info.currentShift='-'
            }
            if (info.currentTurns) {
              _this.productUnit = _this.$t('MachineDashBoard.class4')
            }else{
              _this.productUnit = _this.$t('MachineDashBoard.class1')
            }
            
            let num = new Number(info.continuousRunning)
            _this.getMachineInfo.continuousRunning = num.toFixed(1)
            
            if ( isNaN(info.lastCycle) || !info.lastCycle) {
              _this.getMachineInfo.lastCycle = '-'
            } else {
              let num1 = new Number(info.lastCycle)
              _this.getMachineInfo.lastCycle = num1.toFixed(0)
            }
            if (isNaN(info.standardCycle ) || !info.standardCycle) {
              _this.getMachineInfo.standardCycle = '-'
            } else {
              let num2 = new Number(info.standardCycle)
              _this.getMachineInfo.standardCycle = num2.toFixed(0)
            }
            if (isNaN(info.averageCycle) || !info.averageCycle) {
              _this.getMachineInfo.averageCycle = '-'
            } else {
              let num3 = new Number(info.averageCycle)
              _this.getMachineInfo.averageCycle = num3.toFixed(0)
            }
            if (isNaN(info.bestCycle) || !info.bestCycle) {
              _this.getMachineInfo.bestCycle = '-'
            } else {
              let num4 = new Number(info.bestCycle)
              _this.getMachineInfo.bestCycle = num4.toFixed(0)
            }
            if (isNaN(info.shiftPlan) || !info.shiftPlan) {
              _this.getMachineInfo.shiftPlan = '-'
            } else {
              let num5 = new Number(info.shiftPlan)
              _this.getMachineInfo.shiftPlan = num5.toFixed(0)
            }
            if (isNaN(info.estimateProductivity) || !info.estimateProductivity) {
              _this.getMachineInfo.estimateProductivity = '-'
            } else {
              let num6 = new Number(info.estimateProductivity)
              _this.getMachineInfo.estimateProductivity = num6.toFixed(0)
            }
            if (isNaN(info.currentProductivity) || !info.currentProductivity) {
              _this.getMachineInfo.currentProductivity = '-'
            } else {
              let num7 = new Number(info.currentProductivity)
              _this.getMachineInfo.currentProductivity = num7.toFixed(0)
            }
            _this.machineTimeList=[_this.getMachineInfo.bestCycle,_this.getMachineInfo.averageCycle,_this.getMachineInfo.lastCycle]
            if(_this.getMachineInfo.averageCycle>=300){
              _this.getMachineInfo.averageCycle = _this.s_to_hs(_this.getMachineInfo.averageCycle)
            }
            if(_this.getMachineInfo.lastCycle>=300){
              _this.getMachineInfo.lastCycle = _this.s_to_hs(_this.getMachineInfo.lastCycle)
            }
            if(_this.getMachineInfo.bestCycle>=300){
              _this.getMachineInfo.bestCycle = _this.s_to_hs(_this.getMachineInfo.bestCycle)
            }
            // if(_this.$store.state.lang)
            _this.machineTimeArr=[_this.$t('MachineDashBoard.best'),_this.$t('MachineDashBoard.average'),_this.$t('MachineDashBoard.last')]
            // document.getElementById("myChart").style.display="inline"
            _this.initChart()
          }
        }
        if (data['logs'] !== null) {
          var logs = JSON.parse(data['logs'])
          if (logs) {
            _this.tableData = logs.rows
            _this.totalPage = logs.total
          }
        }
        _this.timeList = data['timeList']
        let total = _this.timeList.length/10
        if (Number.isInteger(total)) {
          _this.timePageSize = total
        } else {
          _this.timePageSize = Number.parseInt(total) + 1
        }
       
        _this.$nextTick(()=>{
          // _this.loadingInstance.close()
          _this.fullscreenLoading = false
        })
        }
      }
      // 连接建立之后执行send方法发送数据
      _this.websock.onopen = function () { 
        _this.toWebsocketSendCon()
      }
      // 连接建立失败重连
      _this.websock.onerror = function () {
        _this.websock = new WebSocket("ws://" + _this.$store.state.websocketws+_this.$store.state.newroute  + "/websocket-dashboardstation")
      }
      // 关闭
      _this.websock.onclose = function () {
        _this.websock = null
      }
    },
    // 向websocket发送筛选条件
    toWebsocketSendCon () {
      let _this = this
       _this.fullscreenLoading = true
      var param = {
        'id': _this.machineId,
        'factoryId': _this.lineVal[0],
        'language':_this.$store.state.lang,
        'condition_startTime': _this.startTimePicker,
        'condition_endTime':  _this.endTimePicker,
        'monthlyProductionTime':_this.timevalue
        //'flag':_this.flag
        // 'shopId': null,
        // 'lineId': null,
        // 'machineId': _this.lineVal[1],
        // 'typeId': null,
        // 'groupId': null,
        // 'emId': null,
        // 'eventCode': null,
        // 'startTime': null,
        // 'endTime': null,
        // 'sort': null,
        // 'pageNum': _this.pageNo
        }
      var params = JSON.stringify(param)
      // 向服务器发送消息
      _this.websock.send(params)
    },
    // 更多按钮跳转
    clickMore () {
      if (this.lineVal[0] == 9) {
        this.$router.push({name: 'FaultVmiAlarmQuery', params: {factoryId: this.lineVal[0],machineId: this.lineVal[1],machineName: this.getMachineInfo.nameEn}}) 
      }else {
        this.$router.push({name: 'FaultAlarmQuery', params: {factoryId: this.lineVal[0],machineId: this.lineVal[1],machineName: this.getMachineInfo.nameEn}}) 
      }
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang,
          machineId: _this.machineId
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(res.data.options !==undefined && res.data.options.length > 0){
            //各工位循环周期时间
            _this.cycleShowId = res.data.machine.id
            _this.cycleShowFactoryId = res.data.machine.factoryId
            // belong: 该页面的机械id是否属于该工厂 1：是 0：不是
            if (res.data.belong === 1) {
              _this.options = res.data.options
              _this.lineVal = [res.data.machine.factoryId, res.data.machine.id]
              _this.noMachine=false
              _this.getMachineById()
              // _this.initWebSocket()
            } else {
              _this.$router.push({path: '/', name: 'home'})
            }
          }else{
              _this.noMachine=true
          }
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
      
    },
        // 获取机器收藏
    getMachineById() {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/selectMachineById',
        params:{
          machineId: _this.machineId
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.isFavorited = res.data.isFavorited
        } else {
          _this.$message.error('Machine loading failed')
        }
      })
    },
    // 改变机械型号触发
    changeLine(){
      this.$router.replace({
        name: 'EquipmentDashBoard', 
        params: {
          id:this.lineVal[this.lineVal.length-1]
        }
      })
      this.$parent.reload()
    },
    addFavorited(){
      let _this = this
      this.axios({
        method: 'POST',
        url: '/url/addFavoriteMachine',
        params: {
          language: _this.$store.state.lang,
          machineId: _this.machineId, // 机器的id
        }
      }).then(function (res) {
        if (res.data.success === 'true') {
          _this.isFavorited = 1
        }
        _this.$message(res.data.msg);
        _this.$refs.mychild.selectFavorite()
      })
    },
    delFavorited(){
      let _this = this
      this.axios({
        method: 'POST',
        url: '/url/deleteFavoriteMachine',
        params: {
          language: _this.$store.state.lang,
          machineId: _this.machineId, // 机器的id
        }
      }).then(function (res) {
        if (res.data.success === 'true') {
          _this.isFavorited = 0
        }
        _this.$message(res.data.msg)
        _this.$refs.mychild.selectFavorite()
      })
    },
    // 下载pdf翻页
    changeTimePage(d){
      if (d === 'l'){
        this.timeNowPage-=1
      }else{
        this.timeNowPage+=1
      }
      this.$refs.wrap.style.top = `${(this.timeNowPage-1)*-150}px`
    },
    // 下载pdf
    dlPdf(t){
      var timeStr = formatDate(new Date(t), 'yyyy-MM-dd')
      let signTime = new Date().getTime()
      this.$store.commit('nowsign', signTime)
      window.open(`/url/pdfExportGanttChartData?machineId=${this.machineId}&downloadTime=${timeStr}&language= ${this.$store.state.lang}&sign=${this.$store.state.sign}&auth_Code=${this.$store.state.authCode}&sign_time=${signTime}&route=${this.$store.state.newroute}&factory_id=${this.$store.state.factoryId}`, '_blank')
    },
    // 图表初始化
    initChart(){
      let _this = this
      _this.barChart = this.$echarts.init(document.getElementById('myChart'))
      _this.barChart.setOption({
        animation:false,
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            },
            formatter:function(params){
                if(params[0].data>=300){
                  params[0].data = _this.s_to_hs(params[0].data)
                  return params[0].axisValue + '<br/>' +
                      params[0].marker+params[0].data.split(":")[0]+'min'+params[0].data.split(":")[1]+'s'
                }else{
                   return params[0].axisValue + '<br/>' +
                     params[0].marker+params[0].data+'s'
                }
              
            }
        },
        grid: {
            left: '1%',
            right: '7%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            axisLabel: {
              formatter:  function (value) {
                if(value < 300) return value + 's';
                else{
                  return _this.s_to_mins(value)
                }
              }
            }
            // boundaryGap: [0, 0.01]
        },
        yAxis: {
            type: 'category',
            data: _this.machineTimeArr
        },
        series: [
            {
                // name: _this.desArr,
                type: 'bar',
                itemStyle: {
                  normal: {color: '#085ba6'}
                },
                data: _this.machineTimeList
            }
          ]
        })
      this.resizeTimer = setInterval(function(){
        _this.barChart.resize()
      },500)
    },
  }
}
</script>


<style scoped>

.machine{
  height: 100%;
  min-width: 1365px!important;
}
.machineMain{
  width:98%;
  height: 100%;
  background-color: #fafafa;
  margin: auto;
  margin-left: 2%;
  border-radius: 6px;
  /* padding:3%; */
  box-sizing:border-box;
}
.maskMain{
  padding:0;
}
.machineInfo{
 position: relative;
 height: 250px;
 overflow: hidden;
 background-color: #e5eef7;
 box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
 border-radius: 4px;
 border:none;
 width: 100%;
 padding:20px;
 box-sizing:border-box;
}
.machineChart{
  display: flex;
  padding-right:5px;
}
.machineInfoTime{
  width: 31%;
  margin-top: 20px;
}
/* .machineChart{
 display: flex;
} */
.chartWrap{
  /* width:65%; */
  flex: 1;
}
#myChart{
  width: 100%;
  height: 200px;
  top:-22px;
  text-align: center;
  /* left:-7%; */
  /* margin-left: 20px; */
  /* margin: 0 5%; */
}
.title_bg{
  float: left;
  width: 100%;
  height: 350px;
  background-image: url(../assets/img/machine/machineBG.png);
  background-position:center;
  background-repeat: no-repeat;
  background-size: 100% auto; 
  -webkit-filter: blur(2px) brightness(180%) contrast(90%);
  -moz-filter: blur(2px) brightness(180%) contrast(90%);
  -o-filter: blur(2px) brightness(180%) contrast(90%);
  -ms-filter: blur(2px) brightness(180%) contrast(90%);
  filter: blur(2px) brightness(180%) contrast(90%);
}
.special_bg{
  background-image: url(../assets/img/machine/131BG.jpg)!important;
}
.machind211_bg{
  background-image: url(../assets/img/machine/TBM211BG.png)!important;
}
.gangsiquan_bg201{
  background-image: url(../assets/img/gsq/gsqBG.png)!important;
}
.gangsiquan_bg202{
  background-image: url(../assets/img/gsq/gsqBG.png)!important;
}
.gangsiquan_bg196{
  background-image: url(../assets/img/gsq/gsqBG.png)!important;
}
.gangsiquan_bg306{
  background-image: url(../assets/img/gsq/gsqBG.png)!important;
}
.gangsiquan_bg307{
  background-image: url(../assets/img/gsq/gsqBG.png)!important;
}
.machineInfo .title{
  overflow: hidden;
  padding: 20px 25px;
  background-color: rgba(255, 255, 255, 0.7);
  border-bottom: 1px solid #e8e8e8;
  position: relative;
  top: -350px;
  left: 0;
}
/* .machineInfo .title p{
  font-size: 24px;
  color: #525f7f;
  line-height: 40px;
  width: calc(100% - 510px);
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis
} */
.machineInfo .title p span{
  margin-right: 15px;
}
.machineInfo .rightWrap{
  float: right;
  display:flex;
  align-items: center;
}
.lineSelect{
  width: 100px;
  margin-right: 5px;
}
.groupWrap{
  position: relative;
  top: -315px;
  left:0;
}
.infoGroup{
  width: 380px;
  background-color: rgba(255, 255, 255, 0.7);
  line-height: 40px;
  margin: 20px auto;
  padding: 0 10px;
  box-sizing: border-box;
  font-size:18px;
  border-radius: 10px;
}
.infoGroup span {
  font-weight: bold;
  margin-left: 10px;
}
.state{
  margin-top: 30px;

}
.stateWrap{
  /* width: 200px;
  border-radius: 15px;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  height: 180px;
  margin: 0 auto;
  text-align: center;
  overflow: hidden; */
  font-size: 1.2em;
  /* line-height: 40px; */
  font-weight: bold;
  margin-top: 20px;
}

.bestTime{
  font-size: 13px;
  font-weight:500;
  color: #808080;
  margin-top: 6px;
}
.ms{
  margin-left: 15px;
}
/* .stateWrap .val{
  font-size: 50px;
  font-weight: bold;
  margin-top: 20px;
}
.stateWrap .ms{
  display:flex;
  justify-content:center;
  align-items:flex-end;
  line-height:1;
}
.stateWrap .ms .vals{
  font-size:28px;
  font-weight:bold;
  margin-left:3px;
  margin-top: 20px;
}
.stateWrap .ms .vals span{
  font-size: 20px;
  font-weight: bold;
}
.stateWrap .val span{
  font-size: 20px;
  font-weight: bold;
}
.stateWrap .dis{
  font-size: 16px;
  margin-top: 30px;
}
.stateWrap .bottomIcon{
  text-align: right;
  box-sizing: border-box;
  padding:0 10px;

}
.stateWrap .langbottomIcon{
  text-align: right;
  box-sizing: border-box;
  padding:0 10px;
  margin-top:-21px;
}
.stateWrap .bottomIcon span{
  font-size: 25px;
  color: #CCC;
}
.stateWrap .langbottomIcon span{
  font-size: 25px;
  color: #CCC;
}
.stateWrap div{
  padding-top:1px; 
}
.cycleWrap{
  width: 290px!important;
  background-color: #ffeb3b;
}
.cycleWrap .last, .cycleWrap .standard{
  width: 50%;
  float: left;
}
.cycleWrap .standard{
  color: rgba(128, 128, 128, 1);
}
.cycleWrap .bottomIcon span:nth-child(1){
  float: left;
}
.last{
  background-color: rgba(244, 204, 28, 0.8);
}
.average{
  background-color: rgba(202, 189, 145, 0.7)
}
.best{
  background-color: rgba(122, 100, 45, 0.8);
}
.shift{
  background-color: rgba(74, 75, 185, 0.8);
}
.estimate{
  background-color: #43cf7c;
}
.current{
  background-color:rgba(100, 82, 61, 0.8)
} */
/* 新增钢丝圈设备背景颜色 */
.bwl{
  background-color: rgb(128 74 216 / 80%);
}
.shift .dis, .estimate .dis, .current .dis, .bwl .dis{
  margin-top: 5px;
}
.shift .tires, .estimate .tires, .current .tires, .bwl .tires{
  text-align: right;
  box-sizing: border-box;
  padding-right: 20px;
  font-size: 20px;
  font-weight: bold;
}
/* 各工位循环周期时间样式 */
.cycleTime{
  height:100%;
  margin-top: 40px;
  background-color: #ede8f8;
  text-align: center;
  padding:10px;
  box-sizing: border-box;
}
.cycleTime-title-box{
  display:flex;
  justify-content:flex-end;
  align-items:center;
  margin-top: 10px;
  margin-bottom: 20px;
}
.cycleTime-title{
  font-weight: bold;
  font-size: 18px;
}
.cycleTime-datePicker{
  display:flex;
  justify-content:space-between;
  align-items:center;
  margin-right:10px;
}
.cycleBodyHead{
  display: flex;
}
.cycleBodyHead{
  background: rgba(211, 246, 255, 1);
  padding: 20px 0 10px;
  border-radius: 8px 8px 0 0;
}
.cycleHead-item{
  margin: 0 auto;
  width: 84px;
  line-height: 22px;
  font-size: 15px;
  color: #fff;
  border-radius: 12px;
  background: rgba(179, 179, 179, 1);
  text-align: center;
}
.cycleHead-item-active{
  background-color: rgba(98, 98, 98, 1);
}
.headLeft{
   width: 84px;
   margin:0 54px;
}
.cycle-headRight{
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.cycleContent-item{
  display: flex;
  background: #fff;
  border-bottom: 1px solid rgba(166, 166, 166, 1);
}
.cycleContent-item:last-child{
  border:none;
  border-radius: 0 0 8px 8px;
}
.cycleImg-box{
  margin: 30px 22px 8px;
}
.cycleImg{
  width: 148px;
  height: 78px;
  border-radius: 10px;
  vertical-align: top;
}
.cycleModel{
  text-align: center;
  color: rgba(80, 80, 80, 1);
	font-size: 14px;
	line-height: 150%;
  margin-top: 6px
}
.ContentItem-left{
  width: 100%;
  display: flex;
  padding: 15px 0;
}
.cycle-leftItem{
  width: 25%;
}
.cycle-second{
  width: 100%;
  margin-top: 15px;
  color: rgba(0, 0, 0, 1);
  font-weight: bold;
  text-align: center;
}
.cycle-secondNum{
	font-size: 3em;
	line-height: 150%;
	text-align: center;
}
.cycle-secondS{
  font-size:1.5em;
  /* margin-left: 15px; */
}
.time{
  color: rgba(117, 117, 117, 1);
	font-size: 14px;
	line-height: 150%;
  text-align: center;
}
.short-border{
  margin-top: 30px;
  width: 1px;
  height: 60px;
  background: rgba(153, 153, 153, 1);
}
.lastNum{
  color: rgba(115, 115, 115, 1);
}

.tableWrap{
  margin: 40px 0 30px;
  height:100%;
  /* height:300px; */
  padding:10px;
  box-sizing: border-box;
  text-align: center;
}
.titleRow label{
  font-size: 12px;
}
.datePick{
  margin: 25px 0;
}
.datePick .btns{
  float: right;
}
.typeIcon{
  /* color: #6772e5; */
  color:#d43030;
}
.pagination{
  text-align: center;
  margin-top: 35px;
}
.mcond{
  color:#808080
}
.info{
  color:#7948ea;
}
.alm{
  color:#f16a4d
}
.flt{
  color:#d43030;
}
.mask{
  display: none;
  position: absolute;
  /* top: 84px; */
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.14);
}
.maskNoMachine{
  display: block;
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-size: 30px;
  word-wrap: break-word;
  padding-top: 10%;
}
.maskLong{
  height: 94%;
}
.mask p{
  text-align: center;
  font-size: 60px;
  margin-top: 85px;
  word-wrap: break-word;
}
.dlcontent{
  padding: 3%;
}
.offlineMask{
  display: block;
  background-color: rgba(255, 255, 255, 0.8);
}
.offlineMask p{
  color:rgba(100, 91, 91, 1);
}
.notConnectedMask{
  display: block;
  background-color: rgba(45, 44, 44, 0.8);
}
.notConnectedMask p{
  color:rgba(186, 180, 180, 1);
}
.statusGroup span{
  margin-left: 55px;
}
.shiftGroup span{
  margin-left: 50px;
}
.bottomIcon p{
  display: inline-block;
  vertical-align: super;
  font-size: 12px;
  color: #ccc;
  margin-right: 10px;
}
.miniTitle-box{
  display: flex;
  justify-content: space-between;
}
.miniTitle{
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
  display: inline-block;
}
.mores{
  padding: 0 10px;
  height: 34px;
  border-radius: 8px;
}
.dlwarp .dlpagination{
  float: right;
}
.dlpagination span{
  font-size: 14px;
  margin: 0 10px;
}
.dlpagination button{
  padding: 7px;
}
.list{
  width: 100%;
  overflow: hidden;
  height: 160px;
  position: relative;
  display:flex;
  justify-content:space-between;
  align-items: center;
}
.list .cardWrap{
  width: 100%;
  position: absolute;
  top: 0;
  left: 30%;
}
.list .cardWrap .card{
  width: 40%;
  height: 110px;
  background-color: #fff;
  float: left;
  position: relative;
  text-align: center;
  padding: 16px 0;
  box-sizing: border-box;
  border-radius: 4px;
  border:1px solid #dcdfe6;
  box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.15);
  margin-right: 60px;
  margin-top: 20px;
  margin-bottom: 20px;
}
.card .date{
  font-size: 30px;
  color: #ccc;
}
.card .date span{
  color: rgba(24, 144, 255, 1);
}
.card .year,.card .id{
  font-size: 14px;
  font-weight: bold;
}
.card .year{
 margin: 3px 0
}
.card .id{
  color: rgba(118, 118, 118, 1)
}
.card .dlMark{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
  line-height: 100px;
  background-color: rgba(255,255,255,0.8)
}
.card .dlMark span{
  font-size: 38px;
  color:  rgba(24, 144, 255, 1);
}
.statusWrap{
  position: relative;
  top: -335px;
  left: 0;
}
.statusWrap{
  display: flex;
}
/* .statusWrap .status{
  width: 290px
}
.statusWrap .currentShift{
  width: 240px
}
.statusWrap .recipe{
  width: 370px
} */
.statusWrap .status,.statusWrap .currentShift,.statusWrap .recipe{
  font-size: 17px;
  margin-left: 2%;
  line-height: 35px;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 10px;
  color:#fff;
}
.statusWrap .status span,  .statusWrap .currentShift span,.statusWrap .recipe span{
  padding: 0 10px;
  display: inline-block; 
  /* float: left; */
  /* width: 55%; */
  box-sizing: border-box;
}
.statusWrap .status span:nth-child(2),.statusWrap .currentShift span:nth-child(2),.statusWrap .recipe span:nth-child(2){
  font-weight: bold;
  /* width: 45%; */
  /* margin-left: 2px; */
  margin-right: 10px;
  text-align: center;
}
.monthlyOutput{
  margin: 30px 0 10px;
  height: 100%;
  margin-top: 40px;
  background-color: #ede8f8;
  padding: 10px;
  box-sizing: border-box;
}
.outputTitle{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.changetime{
 text-align: right;
}
.nowTime{
  margin-left: 5px;
  margin-right: 5px;
}
.output{
  display: flex;
}
.exportBtn{
  width: 80px;
  padding:8px 10px;
  font-size: 13px;
  height: 34px;
  border-radius: 8px;
}
.monthlyOutput .timePicker{
  width: 125px;
  margin: 0 20px;
}
.el-button--mini, .el-button--mini.is-round{
  padding: 8px 8px;
}
/* 产能表格样式 */
.table{
  display: flex;
}
.tableLine{
  width: 100%;
  display: flex;
  align-items:  center;
}
.tableLeft{
  width: 50%;
  text-align: center;
  padding-right: 10px;
}
.tableRight{
  display: flex;
  flex-direction: column;
  width: 48%;
  height: 100%;
  text-align: center;
  float: right;
  padding-left: 10px;
  /* border-left: 1px solid #EBEEF5; */
}
/*右侧侧边栏机器信息*/
.rightBox{
  height: 100%;
  padding:20px 15px;
}
.rightBoxInfo{
  width: 270px;
  background-color: #fafafa;
  border-radius: 6px;
  /* min-height: 100%; */
  padding:20px 15px;
  box-sizing:border-box;
  text-align: center;
}
.rightBox-collect{
  font-size: 24px;
  color: #2a82e4;
  display: flex;
  justify-content: space-between;
}
.rightBox-machinePic{
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-left: 30px;
  /* border: 1px solid #cfd0d1; */
}
.rightBox-machineStatus{
  margin: 20px 0px;
}
.title{
  font-size: 15px;
  color: #000;
  line-height: 30px;
  margin-top: 10px;
}
.rightBox-currentShift{
  width: 240px;
  height: 100px;
  font-size: 14px;
  line-height: 40px;
  background-color: #e5eef7;
  border-radius: 6px;
  margin-top: 25px;
  /* padding:0px 20px; */
  /* box-sizing:border-box; */
}
.rightBox-currentShift-title{
  border-bottom: 1px solid #dcdfe6;
}
.rightBox-currentShift-content{
  font-size: 16px;
  font-weight: bold;
  line-height: 60px;
  padding: 0px 20px;
  box-sizing:border-box;
}
.noTimeListTitle{
  color:#909399;
  line-height: 20px;
  text-align: center;
  font-size: 14px;
}
.ellipsis{
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.rightBox-unit{
  font-size: 13px;
  float: right;
}
.card{
  height: 200px;
}
.event{
  position: relative;
  overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
}
.playIcon{
  color: #0bd70b;
  font-size:16px;
}
.stop{
    color:#4866ea;
}
.offline{
    color:#808080;
}
.fault{
    color:#d43030;
}
.standby{
    color:#cfcf0b;
}
.notConnected{
    color:#383838;
}
.event:hover{
  animation-name: example;
  animation-duration: 8s;
}
@keyframes example {
  0%   { overflow:unset;white-space: unset;left:0px; top:0px;}
  50%  { overflow:unset;white-space: unset;left:-220px; top:0px;}
  100%  { overflow:unset;white-space: unset;left:-220px; top:0px;}
  /* 75%  { overflow:unset;white-space: unset;left:0px; top:0px;}
  100% { overflow:unset;white-space: unset;left:0px; top:0px;} */
}
</style>
